import type { IntegrationId } from '../core/types/insights'

/**
 * Uitleg per externe bron voor Inzicht: wat het oplevert en hoe je hem koppelt. Koppelen gebeurt
 * altijd op de server; in het beheer staan nooit sleutels of wachtwoorden (docs/INZICHT.md §7).
 */
export const integrationInfo: Record<IntegrationId, { name: string; what: string; steps: string[] }> = {
  umami: {
    name: 'Bezoekersstatistiek (Umami)',
    what: 'Hoeveel mensen de site bezoeken, waarvandaan, welke pagina’s en wat ze zoeken. Zonder cookies en zonder iemand te volgen.',
    steps: [
      'Umami draait op onze eigen server (stats.beautybewust.nl).',
      'Zet VITE_UMAMI_URL en VITE_UMAMI_SITE_ID bij het bouwen van de site.',
      'Geef de server een leestoken voor Umami; hij haalt de cijfers elke nacht op.',
    ],
  },
  searchConsole: {
    name: 'Google Search Console',
    what: 'Op welke zoekwoorden de site in Google verschijnt, hoe vaak erop geklikt wordt en op welke plek.',
    steps: [
      'Verifieer het domein beautybewust.nl in Search Console (via DNS).',
      'Meld de sitemap aan: https://beautybewust.nl/sitemap.xml.',
      'Geef het serviceaccount van de server leesrechten op de property.',
    ],
  },
  googleBusiness: {
    name: 'Google Bedrijfsprofiel',
    what: 'Hoe vaak de salon in Google Zoeken en Maps verschijnt, klikken op route, bellen en website, en de nieuwste reviews.',
    steps: [
      'Vraag API-toegang aan bij Google (beoordeling duurt 1 tot 4 weken).',
      'Log daarna één keer in met het Google-account van de salon, via de server (OAuth).',
      'Kies het profiel van Beauty Bewust; de server haalt de cijfers elke nacht op.',
    ],
  },
  instagram: {
    name: 'Instagram',
    what: 'Bereik, likes, opslaan en linkkliks per post, de groei van je volgers en het beste moment om te posten.',
    steps: [
      'Zorg dat het Instagram-account zakelijk of creator is.',
      'Log één keer in met Instagram via de server (OAuth). Een wachtwoord komt nooit in het beheer.',
      'Koppel daarna in de Social planner een geplaatste post aan de echte post voor de cijfers erbij.',
    ],
  },
  brevo: {
    name: 'Brevo (mail)',
    what: 'Opens, kliks, afmeldingen en bounces van de nieuwsbrief en de automatische mails.',
    steps: ['De Brevo-sleutel staat op de server (docs/BREVO.md).', 'Zet de webhooks voor geopend, geklikt en bounces aan.'],
  },
}
